/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
import type { RuleHistory } from './RuleHistory';
import {
  RuleHistoryFromJSON,
  RuleHistoryFromJSONTyped,
  RuleHistoryToJSON,
} from './RuleHistory';

/**
 * Rule execution states
 * @export
 * @interface ItemHistory
 */
export interface ItemHistory {
  /**
   * total call attempts
   * @type {number}
   * @memberof ItemHistory
   */
  callAttempts?: number;
  /**
   * The last call id
   * @type {number | null}
   * @memberof ItemHistory
   */
  lastCallId?: number | null;
  /**
   * most recent call or sms categories with dispositions
   * @type {Array<string> | null}
   * @memberof ItemHistory
   */
  lastCategories?: Array<ItemHistoryLastCategoriesEnum> | null;
  /**
   * a unique id to reference the last error for support/logs
   * @type {string | null}
   * @memberof ItemHistory
   */
  lastErrorId?: string | null;
  /**
   * per-rule history - key is rule.id
   * @type {{ [key: string]: RuleHistory; }}
   * @memberof ItemHistory
   */
  rules?: { [key: string]: RuleHistory };
  /**
   * timegate attempts
   * @type {number}
   * @memberof ItemHistory
   */
  timegateAttempts?: number;
}

/**
 * @export
 */
export const ItemHistoryLastCategoriesEnum = {
  CallpowerdialerNoAvailableAgent: 'call:powerdialer_no_available_agent',
  CalloutboundConnected: 'call:outbound_connected',
  CallpowerdialerVmDrop: 'call:powerdialer_vm_drop',
  CallmachineDetected: 'call:machine_detected',
  CallpowerdialerCall: 'call:powerdialer_call',
  Callactive: 'call:active',
  Calloutbound: 'call:outbound',
  Callcancelled: 'call:cancelled',
  Callinbound: 'call:inbound',
  Callmissed: 'call:missed',
  Callanswered: 'call:answered',
  Callabandoned: 'call:abandoned',
  CalluserInitiated: 'call:user_initiated',
  Smsaccepted: 'sms:accepted',
  SmsinvalidDestination: 'sms:invalid_destination',
  SmsinvalidSource: 'sms:invalid_source',
  SmsnoRoute: 'sms:no_route',
  SmsrejectedSpam: 'sms:rejected_spam',
  SmsinternalError: 'sms:internal_error',
  Smsrejected: 'sms:rejected',
  SmsnotSupported: 'sms:not_supported',
  SmstimeOut: 'sms:time_out',
  Smserror: 'sms:error',
  Smsunknown: 'sms:unknown',
  SmsownerNoInternationalMessaging: 'sms:owner_no_international_messaging',
  SmsunregisteredA2pNotAllowed: 'sms:unregistered_a2p_not_allowed',
  SmsownerNotEnoughSmsCredits: 'sms:owner_not_enough_sms_credits',
  SmsownerNotEnoughCredits: 'sms:owner_not_enough_credits',
  SmsmessagingDisabled: 'sms:messaging_disabled',
  SmsownerFreeUser: 'sms:owner_free_user',
  SmscontactMissingNumber: 'sms:contact_missing_number',
  SmscontactIsRoom: 'sms:contact_is_room',
  SmscontactIsSharedLine: 'sms:contact_is_shared_line',
  SmsstaffContact: 'sms:staff_contact',
  SmscompanyAffinity: 'sms:company_affinity',
  SmsnotInFreeCompany: 'sms:not_in_free_company',
  SmsinvalidNumber: 'sms:invalid_number',
} as const;
export type ItemHistoryLastCategoriesEnum =
  (typeof ItemHistoryLastCategoriesEnum)[keyof typeof ItemHistoryLastCategoriesEnum];

/**
 * Check if a given object implements the ItemHistory interface.
 */
export function instanceOfItemHistory(value: object): value is ItemHistory {
  return true;
}

export function ItemHistoryFromJSON(json: any): ItemHistory {
  return ItemHistoryFromJSONTyped(json, false);
}

export function ItemHistoryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ItemHistory {
  if (json == null) {
    return json;
  }
  return {
    callAttempts:
      json['call_attempts'] == null ? undefined : json['call_attempts'],
    lastCallId: json['last_call_id'] == null ? undefined : json['last_call_id'],
    lastCategories:
      json['last_categories'] == null ? undefined : json['last_categories'],
    lastErrorId:
      json['last_error_id'] == null ? undefined : json['last_error_id'],
    rules:
      json['rules'] == null
        ? undefined
        : mapValues(json['rules'], RuleHistoryFromJSON),
    timegateAttempts:
      json['timegate_attempts'] == null ? undefined : json['timegate_attempts'],
  };
}

export function ItemHistoryToJSON(value?: ItemHistory | null): any {
  if (value == null) {
    return value;
  }
  return {
    call_attempts: value['callAttempts'],
    last_call_id: value['lastCallId'],
    last_categories: value['lastCategories'],
    last_error_id: value['lastErrorId'],
    rules:
      value['rules'] == null
        ? undefined
        : mapValues(value['rules'], RuleHistoryToJSON),
    timegate_attempts: value['timegateAttempts'],
  };
}
